/**
 * Created by Denis Kuzin on 27 march 2025
 */

const OrderManager = function (slot) {
    cleverapps.EventEmitter.call(this);
    this.slot = slot;
    this.index = this.slot.load("order") || 0;

    const simpleGeneratorProvider = new GeneratorDataProvider(this);
    this.simpleAlgorithm = new SimpleAlgorithm(simpleGeneratorProvider);

    this.load();
};

OrderManager.prototype = Object.create(cleverapps.EventEmitter.prototype);
OrderManager.prototype.constructor = OrderManager;

OrderManager.prototype.inc = function () {
    this.setOrderIndex(this.index + 1);

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.LOCATION_ORDER}_${this.index}`);
};

OrderManager.prototype.setOrderIndex = function (index) {
    this.index = index;
    this.slot.save("order", this.index);
};

OrderManager.prototype.reset = function () {
    this.setOrderIndex(0);
};

OrderManager.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.ORDER_MANAGER) || {};
    this.ingredientsHistory = data.ingredientsHistory || [];

    if (cleverapps.config.debugMode) {
        this.surplusHistory = data.surplusHistory || {};
    }
};

OrderManager.prototype.getData = function () {
    return {
        ingredientsHistory: this.ingredientsHistory,
        surplusHistory: this.surplusHistory
    };
};

OrderManager.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.ORDER_MANAGER, this.getData());
};

OrderManager.prototype.generateOrder = function () {
    if (cleverapps.config.debugMode) {
        this.surplusHistory[this.index] = Math.floor(this.simpleAlgorithm.volumeBalancer.status().surplus);
    }

    const ingredients = this.simpleAlgorithm.next().map((ingredient) => {
        this.ingredientsHistory.push(ingredient);

        if (this.ingredientsHistory.length > 10) {
            this.ingredientsHistory.shift();
            if (this.findSequenceProblems(this.ingredientsHistory)) {
                this.ingredientsHistory = [];
            }
        }
        return {

            unit: {
                code: ingredient.line,
                stage: ingredient.stage
            },
            amount: 1
        };
    });

    return {
        ingredients,
        index: this.index
    };
};

OrderManager.prototype.findSequenceProblems = function (ingredientsHistory) {
    const lineBalancer = this.simpleAlgorithm.lineBalancer;
    let message = "";

    const allLinesIsSame = Object.keys(lineBalancer.balances).length > 1 && ingredientsHistory.every((ingredient) => ingredient.line === ingredientsHistory[0].line);

    if (allLinesIsSame) {
        message += "10 ingredients with the same code in a row";
    }

    if (message) {
        const surplus = this.simpleAlgorithm.volumeBalancer.surplusEWMA;
        const lineBalance = JSON.stringify(lineBalancer.balances);
        message += `\nlineBalancer ${JSON.stringify(lineBalance)}`;
        message += `\ningredientsHistory ${JSON.stringify(ingredientsHistory)}`;
        message += `\nsurplus ${surplus}`;
        cleverapps.throwAsync(message);
        return true;
    }
};

OrderManager.prototype.calcOrderInfo = function (recipe) {
    const order = recipe.ingredients.map((ingredient) => ({
        line: ingredient.unit.code,
        stage: ingredient.unit.stage
    }));

    if ([-Infinity, Infinity].includes(this.surplusHistory[recipe.index])) {
        this.surplusHistory[recipe.index] = 0;
    }

    return {
        surplus: this.surplusHistory[recipe.index],
        index: recipe.index,
        volume: Math.floor(this.simpleAlgorithm.dataSource.getOrderVolume(order)),
        target: this.simpleAlgorithm.dataSource.getTargetVolume(),
        cap: this.simpleAlgorithm.dataSource.getCapLimit()
    };
};

OrderManager.prototype.destructor = function () {
    runCleaners(this);
};